import { Component, OnInit } from '@angular/core';
import { MenuService } from '@app/menu/services/menu.service';
import { RouterService } from '@app/routing/router.service';
import { RouteDetectionService } from '@app/shared/services/route-detection.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'portal-enterprise-sub-nav',
  templateUrl: './enterprise-sub-nav.component.html',
  host: {
    class: 'sub-nav-container',
  },
  standalone: false,
})
export class EnterpriseSubNavComponent implements OnInit {
  public readonly isOnEndUserLevel$: Observable<boolean> = this.menuService.menuData$.pipe(
    map((state) => state.activeUserLevels),
    map((levels) => levels.isEnterprise && levels.isEndUser),
    untilDestroyed(this)
  );

  public readonly isOnEnterpriseLevel$: Observable<boolean> = this.menuService.menuData$.pipe(
    map((state) => state.activeUserLevels),
    map((levels) => levels.isEnterprise && levels.isEndUser === false),
    untilDestroyed(this)
  );

  public showFeatureSubNav: boolean = false;

  public isAcd!: boolean;
  public isCallCenter!: boolean;
  public isSite!: boolean;

  constructor(
    private menuService: MenuService,
    private routeDetectionService: RouteDetectionService,
    private routerService: RouterService
  ) {}

  public ngOnInit() {
    this.routerService.routeChanged$
      .pipe(untilDestroyed(this))
      .subscribe((route) => this.decideFeatureSubNav(route.url));

    this.decideFeatureSubNav(this.routerService.currentRouteData.url);
  }

  private decideFeatureSubNav(url: string) {
    this.isAcd = this.routeDetectionService.isAcdRoute(url);
    this.isCallCenter = this.routeDetectionService.isCallCenterQueueRoute(url);
    this.isSite = this.routeDetectionService.isSiteRoute(url);

    this.showFeatureSubNav = this.isAcd || this.isCallCenter || this.isSite;
  }
}
